<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Add Student",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Add Students",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Manage Students",
          href: "/students",
        },
        {
          text: "Add Students",
          active: true,
        },
      ],
      data: {
        name: "",
        photo: "",
        dob: "",
        gender: "",
        class: "",
        course: "",
        entryStatus: "",
        resident: "",
        gcontact: "",
        gemail: "",
        guardian: "",
        lin: "",
        code: "",
        stdContact: "",
        occupation: "",
        email: "",
        address: "",
      },
      existingStudent: [],
      errors: {
        name: "",
        photo: "",
        dob: "",
        gender: "",
        class: "",
        course: "",
        entryStatus: "",
      },
      modal: "",
      // pageData: { minDob: "" },
    };
  },
  computed: {
    ...mapGetters("students", ["AllStudents", "SaveStatus"]),
    ...mapGetters("classes", [
      "CustomClasses",
      "AllCourses",
      "AllClasses",
      "AllClassStreams",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.AllStudents.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllStudents.length;
  },
  methods: {
    ...mapActions({
      FetchStudents: "students/fetchStudents",
      AddStudent: "students/addStudent",
      EditStudent: "students/editStudent",
      DeleteStudents: "students/deleteStudents",
      FetchStreams: "classes/fetchStreams",
      FetchClassStreams: "classes/fetchClassStreams",
      FetchCourses: "classes/fetchCourses",
      FetchCustomClasses: "classes/fetchCustomClasses",
    }),

    //Handling student's photo
    handleFileUpload(event) {
      this.data.photo = event.target.files[0];
    },

    //Handling edit student's photo
    handleFileUploadEdit(event) {
      this.editStudent.photo = event.target.files[0];
    },

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.AllStudents.length;
      this.currentPage = 1;
    },

    resetError() {
      this.errors.name = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.data.photo = "";
      this.data.dob = "";
      this.data.gender = "";
      this.data.class = "";
      this.data.course = "";
      this.data.entryStatus = "";
      this.data.resident = "";
      this.data.gcontact = "";
      this.data.gemail = "";
      this.data.guardian = "";
      this.data.lin = "";
      this.data.code = "";
      (this.data.stdContact = ""),
        (this.data.occupation = ""),
        (this.data.email = ""),
        (this.data.address = ""),
        this.resetError();
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingStudent = this.AllStudents.filter((student) => {
          return student.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingStudent.length) {
          this.errors.name = this.data.name + " Already Exists";
        } else {
          this.errors.name = "";
        }
      } else {
        this.existingStudent = [];
      }
    },
    addStudent(modal) {
      this.modal = modal;
      let studentData = new FormData();
      //setting up form data for the uploads
      studentData.append("name", this.data.name);
      studentData.append("photo", this.data.photo);
      studentData.append("dob", this.data.dob);
      studentData.append("gender", this.data.gender);
      studentData.append("class", this.data.class);
      studentData.append("course", this.data.course);
      studentData.append("entryStatus", this.data.entryStatus);
      studentData.append("resident", this.data.resident);
      studentData.append("guardian", this.data.guardian);
      studentData.append("gemail", this.data.gemail);
      studentData.append("gcontact", this.data.gcontact);
      studentData.append("stdContact", this.data.stdContact);
      studentData.append("occupation", this.data.occupation);
      studentData.append("email", this.data.email);
      studentData.append("address", this.data.address);
      this.AddStudent(studentData);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    fetchLevelinCourse() {
      const courseSelected = {
        course: this.data.course,
      };
      //fetching levels in course
      this.FetchCustomClasses(courseSelected);
    },
  },
  created() {
    this.FetchStudents();
    this.FetchCourses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('add_student')
        )
      "
    >
      <div class="col-12">
        <div class="card row">
          <form @submit.prevent="addStudent">
            <div class="card-body col-11 mx-auto row">
              <div class="col-12">
                <strong class="text-primary">Academic Details</strong>
                <hr />
              </div>
              <div class="form-group col-md-4 mb-3">
                <label
                  >Student Name <small class="text-danger">*</small>
                </label>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Enter Student's Name"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.name"
                    required
                  />
                </div>
                <div class="text-danger" v-if="errors.name">
                  <em>{{ errors.name }}</em>
                </div>
              </div>

              <div class="form-group col-md-4 mb-3">
                <label>Student's Photo</label>
                <small class="text-primary"> (Optional) </small>
                <div class="input-group">
                  <input
                    @change="handleFileUpload($event)"
                    class="form-control"
                    type="file"
                    accept="image/*"
                    id="student-photo"
                  />
                </div>
                <div class="text-danger" v-if="errors.photo">
                  <em>{{ errors.photo }}</em>
                </div>
              </div>

              <div class="form-group col-md-4 mb-3">
                <label>Gender <small class="text-danger">*</small></label>
                <div class="input-group">
                  <select required v-model="data.gender" class="form-control">
                    <option selected value="" disabled>Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div class="text-danger" v-if="errors.gender">
                  <em>{{ errors.gender }}</em>
                </div>
              </div>

              <div class="form-group col-md-4 mb-3">
                <label
                  >Date of Birth <small class="text-danger">*</small></label
                >
                <div class="input-group">
                  <b-form-input
                    id="dob"
                    v-model="data.dob"
                    name="dob"
                    type="date"
                  ></b-form-input>
                </div>
                <div class="text-danger" v-if="errors.dob">
                  <em>{{ errors.dob }}</em>
                </div>
              </div>

              <div class="form-group col-md-4 mb-3">
                <label
                  >Assign Course <small class="text-danger">*</small></label
                >
                <div class="input-group">
                  <select
                    required
                    v-model="data.course"
                    class="form-control"
                    @change="fetchLevelinCourse()"
                  >
                    <option v-if="SaveStatus" selected value="" disabled>
                      Fetching Courses...
                    </option>
                    <option v-else selected value="" disabled>
                      Select Course
                    </option>
                    <option
                      v-for="(course, index) in AllCourses"
                      :key="index"
                      :value="course.id"
                    >
                      {{ course.name }}
                    </option>
                  </select>
                </div>
                <div class="text-danger" v-if="errors.course">
                  <em>{{ errors.course }}</em>
                </div>
              </div>

              <div class="form-group col-md-4 mb-3">
                <label
                  >Assign Levels <small class="text-danger">*</small></label
                >
                <div class="input-group">
                  <select required v-model="data.class" class="form-control">
                    <option v-if="SaveStatus" selected value="" disabled>
                      Fetching Levels...
                    </option>
                    <option v-else selected value="" disabled>
                      Select Level
                    </option>
                    <option
                      v-for="(classes, index) in CustomClasses"
                      :key="index"
                      :value="classes.id"
                    >
                      {{ classes.short }}
                    </option>
                  </select>
                </div>
                <div class="text-danger" v-if="errors.class">
                  <em>{{ errors.class }}</em>
                </div>
              </div>

              <div class="form-group col-md-4 mb-3">
                <label>Entry Status <small class="text-danger">*</small></label>
                <div class="input-group">
                  <select
                    required
                    v-model="data.entryStatus"
                    class="form-control"
                  >
                    <option selected value="" disabled>Select Status</option>
                    <option value="2">New Student</option>
                    <option value="1">Continuing Student</option>
                  </select>
                </div>
                <div class="text-danger" v-if="errors.entryStatus">
                  <em>{{ errors.entryStatus }}</em>
                </div>
              </div>

              <!-- <div class="form-group col-md-4 mb-3">
                <label>LIN Number</label>
                <div class="input-group">
                  <b-form-input
                    id="lin"
                    v-model="data.lin"
                    name="lin"
                    type="text"
                    placeholder="Enter LIN Number"
                  ></b-form-input>
                </div>
              </div> -->

              <!-- <div class="form-group col-md-4 mb-3">
                <label>Pay Code</label>
                <div class="input-group">
                  <b-form-input
                    id="code"
                    v-model="data.code"
                    name="code"
                    type="text"
                    placeholder="Enter Student Pay Code"
                  ></b-form-input>
                </div>
              </div> -->

              <div class="form-group col-md-4 mb-3">
                <label>Contact Number(s)</label>
                <small class="text-primary"> (Optional) </small>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Enter Contact"
                    class="form-control"
                    v-model="data.stdContact"
                  />
                </div>
              </div>

              <div class="form-group col-md-4 mb-3">
                <label>Occupation</label>
                <small class="text-primary"> (Optional) </small>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Enter Occupation"
                    class="form-control"
                    v-model="data.occupation"
                  />
                </div>
              </div>

              <div class="form-group col-md-4 mb-3">
                <label>Email </label>
                <small class="text-primary"> (Optional) </small>
                <div class="input-group">
                  <input
                    type="email"
                    placeholder="Enter Student's Email"
                    class="form-control"
                    v-model="data.email"
                  />
                </div>
              </div>

              <div class="form-group col-md-4 mb-3">
                <label>Student Address </label>
                <small class="text-primary"> </small>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Enter Address"
                    class="form-control"
                    v-model="data.address"
                    required
                  />
                </div>
              </div>

              <div class="col-12 mt-3">
                <strong class="text-primary">Parents Details</strong>
                <hr />
              </div>
              <div class="form-group col-md-6 mb-3">
                <label
                  >Next of Kin Name <small class="text-danger">*</small></label
                >
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Next of Kin Name"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.guardian"
                    required
                  />
                </div>
                <div class="text-danger" v-if="errors.gurdian">
                  <em>{{ errors.gurdian }}</em>
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>Next of Kin Email</label>
                <small class="text-primary"> (Optional) </small>
                <div class="input-group">
                  <input
                    type="email"
                    placeholder="Enter Next of Kin Email"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.gemail"
                  />
                </div>
                <div class="text-danger" v-if="errors.gemail">
                  <em>{{ errors.gemail }}</em>
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>Residents of <small class="text-danger">*</small></label>
                <small class="text-primary">
                  (Give a list e.g District, County, ...)
                </small>
                <textarea
                  v-model="data.resident"
                  class="form-control"
                  :maxlength="30"
                  rows="2"
                  required
                  placeholder="Enter a list with comma separations"
                ></textarea>
                <div class="text-danger" v-if="errors.resident">
                  <em>{{ errors.resident }}</em>
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label
                  >Next of Kin contact Number(s)
                  <small class="text-danger">*</small></label
                >
                <small class="text-primary">
                  (List the contacts e.g 07..., 07...)
                </small>
                <textarea
                  v-model="data.gcontact"
                  class="form-control"
                  :maxlength="30"
                  rows="2"
                  required
                  placeholder="Enter a list with comma separations e.g 07..., 07..."
                ></textarea>
                <div class="text-danger" v-if="errors.gcontact">
                  <em>{{ errors.gcontact }}</em>
                </div>
              </div>
              <div class="col-12">
                <hr />
              </div>
              <div class="col-12">
                <button
                  v-if="SaveStatus"
                  type="button"
                  disabled
                  class="btn btn-primary btn-sm float-end"
                >
                  <b-spinner variant="light" small label="Spinning"></b-spinner>
                  Submiting...
                </button>
                <button
                  v-else
                  type="submit"
                  class="btn btn-outline-primary btn-sm float-end"
                >
                  <i class="fa fa-check"></i>
                  Submit Student
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
